import React, {useState, useEffect} from 'react';
import Time from '../Time';
import Notify from '../Notify';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'
import Comments from './Comments';

class NotificationInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentsWindowStatus:false
    };

    this.openComments = this.openCloseComments.bind(this);

  }

 
  componentDidMount(){
  }

  openCloseComments = () =>{

    console.log("Comments")
    let windowStatus = this.state.commentsWindowStatus;
    
    this.setState({commentsWindowStatus:!windowStatus})

  }

  render() {

    let commentsWindow;

    if(this.state.commentsWindowStatus){
      commentsWindow = <Comments id={this.props.commentsId} user={this.props.user} close={this.openCloseComments}/>
    }


    return(
    <div>
      {commentsWindow}
      <div className='pop-up' onClick={this.props.close}></div>
      <div className="container pop-up-window">
        <header>
          <div className="row container p-1">
            <div className='col-11'>
              <h3>Details</h3>
            </div>
            <div className='col-1'>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              </div>
            </div>
          </div>
        </header>
        <div className='wrapper-white'>
          <div className='container-fluid'>
            <div className="row">
              <div className="col-12 container p-4">
                <p>Notification Id: {this.props.id}</p>
                <p>Created by: {this.props.generatedBy}</p>
                <p>Created date: {this.props.date}</p>
                <p>Seen date: {this.props.seenDate}</p>
                <p>Priority: {this.props.priority}</p>
                <p>Text: {this.props.text}</p>
                <p>Snooze Count: {this.props.snoozeCount}</p>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="row m-2 mb-3">
            <div className='col-12'>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button onClick={this.openCloseComments}>Comments</button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    );
  }
}

export default NotificationInfo;